import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useAuthenticatedUser, useLocalize, useMixpanel } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import InboxTaskItem from '../components/InboxTaskItem';

export default function InboxEvaluationOpenTask({
	task,
	onAction,
	refresh,
}: {
	task: graphql.InboxTask;
	onAction: () => void;
	refresh: () => void;
}) {
	const mixpanel = useMixpanel();
	const history = useHistory();
	const { t } = useTranslation();
	const authenticatedUser = useAuthenticatedUser();
	const { localize } = useLocalize();
	const [archive] = graphql.useArchiveInboxTaskMutation();

	const evaluation = task.evaluationSubmission;

	if (!evaluation) {
		return null;
	}

	const isEmployee = evaluation.employee.user.id === authenticatedUser.id;

	const { employee, manager } = evaluation;

	const status = isEmployee ? employee.status : manager.status;

	const requiresInput = isEmployee ? employee.requiresInput : manager.requiresInput;

	const canSign = isEmployee ? employee.viewerCanSign : manager.viewerCanSign;

	const momentName = localize(
		evaluation.moment?.momentTemplate.title ?? evaluation.evaluationForm.title,
	).text;

	const onClick = () => {
		mixpanel?.track('inbox.tasks.evaluationOpen.view');
		onAction();
		history.push(`/users/${employee.user.id}/conversations/${evaluation.id}`);

		if (!requiresInput && !canSign) {
			archive({ variables: { input: { id: task.id } } });
		}
	};

	return (
		<InboxTaskItem
			task={task}
			onClick={onClick}
			title={t(
				`inbox.tasks.${
					requiresInput
						? status === graphql.EvaluationSubmissionStatus.Draft
							? 'evaluationFillInAndShare'
							: 'evaluationToSign'
						: 'evaluationNoInput'
				}${isEmployee ? 'Self' : ''}.title`,
				{
					momentName,
					targetEmployeeFullName: `${employee.user.firstName} ${employee.user.lastName}`,
				},
			)}
			date={task.createdAt}
			buttonTitle={t('inbox.tasks.button.view')}
			refresh={refresh}
		/>
	);
}
